import { type FC } from 'react'

import {
  FreeformTextareaEditor,
  type FreeformTextareaProps
} from '../FreeformTextareaEditor/FreeformTextareaEditor'

export const SQLEditor: FC<FreeformTextareaProps> = ({ ...props }) => (
  <FreeformTextareaEditor {...props} language="sql" />
)
